module.exports = __webpack_public_path__ + "static/media/Lahore High court, an albumen photo, c. 1880s.da25df1a.jpg";